module.exports = __webpack_public_path__ + "static/media/import.ca5cfa52.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/import.mp4
// module id = 235
// module chunks = 0